import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import VgClientPlacedAd from './VgClientPlacedAd';
import { updateWallpaperPosition } from '../../ads/helpers';

export default class HorseshoeAd extends Component {
    static propTypes = {
        clientPlacedAds: PropTypes.arrayOf(PropTypes.object).isRequired,
        device: PropTypes.string.isRequired,
    };

    state = {
        wallpaperUpdated: false,
    };

    updateWallpaperPosition(ref, subtype) {
        const node = findDOMNode(ref);

        if (node && subtype === 'topboard' && this.state.wallpaperUpdated === false) {
            updateWallpaperPosition(node);
            this.setState({
                wallpaperUpdated: true,
            });
        }
    }

    renderAd(subtype) {
        if (this.props.device !== 'desktop' && subtype !== 'topboard') {
            return null;
        }

        return (
            <VgClientPlacedAd
                subtype={subtype}
                clientPlacedAds={this.props.clientPlacedAds}
                ref={(ref) => this.updateWallpaperPosition(ref, subtype)}
            />
        );
    }

    renderStickyAd(subtype, className) {
        if (this.props.device !== 'desktop') {
            return null;
        }

        return (
            <Sticky enabled top={58} bottomBoundary="main" className={className}>
                {this.renderAd(subtype)}
            </Sticky>
        );
    }

    render() {
        return (
            <div className="horseshoe">
                {this.renderAd('wallpaper')}
                {this.renderAd('topboard')}
                {this.renderStickyAd('skyscraperleft_1', 'skyscraperleft')}
                {this.renderStickyAd('skyscraperright_1', 'skyscraperright')}
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/local-components/Ads/HorseshoeAd.js
 **/